<!--
Desc: 上传证件照片
 -->
<template>
    <div class="ocr-upd comp">
        <el-dialog
            class="prop"
            :title="title"
            :visible="visible"
            :width="width"
            :before-close="dialogClose"
        >
            <div class="ocr-upd-tip">
                <img src="@/assets/img/icon-warning.png" alt="" />
                <span>
                    单张图片大小不得超过{{ $cache.getOcrFileSize() }}M，且仅支持BMP、JPG、JPEG、PNG格式。
                </span>
            </div>
            <el-row class="up-list-ocr-dialog" :span="24">
                <el-tabs v-model="activeTab" v-if="isShowWechatScan">
                    <el-tab-pane label="微信上传" name="wechat">
                        <div class="tips">
                            根据《金融机构客户身份证识别和客户身份资料及交易记录保存管理办法》相关规定，为了您的账户安全，请上传开户证件照，本次操作预计可在20秒内完成，{{ $cache.getCompanyInfoParam("10101014") }}保障您的隐私安全，信息仅用于身份验证。
                        </div>
                        <wx-scan-upload :certType="certType" :isShow="activeTab === 'wechat'" @wxSuccess="wxScanSuccess" @cancel="dialogClose"></wx-scan-upload>
                    </el-tab-pane>
                    <el-tab-pane label="电脑上传" name="local">
                    </el-tab-pane>
                </el-tabs>
                <div v-if="(isShowWechatScan && activeTab === 'local') || !isShowWechatScan">
                    <div :class="{'tips': true,'tips-margin': !isShowWechatScan}">
                        根据《金融机构客户身份证识别和客户身份资料及交易记录保存管理办法》相关规定，为了您的账户安全，请上传开户证件照，本次操作预计可在20秒内完成，{{ $cache.getCompanyInfoParam("10101014") }}保障您的隐私安全，信息仅用于身份验证。
                    </div>
                    <el-form :model="img">
                            <el-form-item label="">
                                <div class="img-up-box">
                                    <div class="img-up-list el-upload-list--picture-card">
                                        <div
                                            v-if="imgBase64.image1"
                                            class="el-upload-list__item-actions"
                                        >
                                            <i
                                                class="el-icon-delete"
                                                aria-hidden="true"
                                                v-on:click="delImg('image1')"
                                            />
                                        </div>
                                        <el-input
                                            v-model="img.image1"
                                            type="file"
                                            name="image1"
                                            :accept="accept"
                                            v-on:change="getImgBase('image1')"
                                        />
                                        <div class="img-up img-load-status">
                                            <img
                                                v-if="imgBase64.image1"
                                                :src="imgBase64.image1"
                                                alt=""
                                            />
                                            <img
                                                v-else
                                                :src="require('../../assets/img/othreUp-bg.png')"
                                                alt=""
                                            />
                                        </div>
                                    </div>
                                    <div class="img-up-list el-upload-list--picture-card">
                                        <div
                                            v-if="imgBase64.image2"
                                            class="el-upload-list__item-actions"
                                        >
                                            <i
                                                class="el-icon-delete"
                                                aria-hidden="true"
                                                v-on:click="delImg('image2')"
                                            />
                                        </div>
                                        <el-input
                                            v-model="img.image2"
                                            type="file"
                                            name="image2"
                                            :accept="accept"
                                            v-on:change="getImgBase('image2')"
                                        />
                                        <div class="img-up img-load-status">
                                            <img
                                                v-if="imgBase64.image2"
                                                :src="imgBase64.image2"
                                                alt=""
                                            />
                                            <img
                                                v-else
                                                :src="require('../../assets/img/othreUp-bg.png')"
                                                alt=""
                                            />
                                        </div>
                                    </div>
                                    <div class="img-up-list el-upload-list--picture-card">
                                        <div
                                            v-if="imgBase64.image3"
                                            class="el-upload-list__item-actions"
                                        >
                                            <i
                                                class="el-icon-delete"
                                                aria-hidden="true"
                                                v-on:click="delImg('image3')"
                                            />
                                        </div>
                                        <el-input
                                            v-model="img.image3"
                                            type="file"
                                            name="image3"
                                            :accept="accept"
                                            v-on:change="getImgBase('image3')"
                                        />
                                        <div class="img-up img-load-status">
                                            <img
                                                v-if="imgBase64.image3"
                                                :src="imgBase64.image3"
                                                alt=""
                                            />
                                            <img
                                                v-else
                                                :src="require('../../assets/img/othreUp-bg.png')"
                                                alt=""
                                            />
                                        </div>
                                    </div>
                                    <div
                                        v-if="showMore"
                                        class="img-up-list el-upload-list--picture-card"
                                    >
                                        <div
                                            v-if="imgBase64.image4"
                                            class="el-upload-list__item-actions"
                                        >
                                            <i
                                                class="el-icon-delete"
                                                aria-hidden="true"
                                                v-on:click="delImg('image4')"
                                            />
                                        </div>
                                        <el-input
                                            v-model="img.image4"
                                            type="file"
                                            name="image4"
                                            :accept="accept"
                                            v-on:change="getImgBase('image4')"
                                        />
                                        <div class="img-up img-load-status">
                                            <img
                                                v-if="imgBase64.image4"
                                                :src="imgBase64.image4"
                                                alt=""
                                            />
                                            <img
                                                v-else
                                                :src="require('../../assets/img/othreUp-bg.png')"
                                                alt=""
                                            />
                                        </div>
                                    </div>
                                    <div
                                        v-if="showMore"
                                        class="img-up-list el-upload-list--picture-card"
                                    >
                                        <div
                                            v-if="imgBase64.image5"
                                            class="el-upload-list__item-actions"
                                        >
                                            <i
                                                class="el-icon-delete"
                                                aria-hidden="true"
                                                v-on:click="delImg('image5')"
                                            />
                                        </div>
                                        <el-input
                                            v-model="img.image5"
                                            type="file"
                                            name="image5"
                                            :accept="accept"
                                            v-on:change="getImgBase('image5')"
                                        />
                                        <div class="img-up img-load-status">
                                            <img
                                                v-if="imgBase64.image5"
                                                :src="imgBase64.image5"
                                                alt=""
                                            />
                                            <img
                                                v-else
                                                :src="require('../../assets/img/othreUp-bg.png')"
                                                alt=""
                                            />
                                        </div>
                                    </div>
                                    <div
                                        v-if="showMore"
                                        class="img-up-list el-upload-list--picture-card"
                                    >
                                        <div
                                            v-if="imgBase64.image6"
                                            class="el-upload-list__item-actions"
                                        >
                                            <i
                                                class="el-icon-delete"
                                                aria-hidden="true"
                                                v-on:click="delImg('image6')"
                                            />
                                        </div>
                                        <el-input
                                            v-model="img.image6"
                                            type="file"
                                            name="image6"
                                            :accept="accept"
                                            v-on:change="getImgBase('image6')"
                                        />
                                        <div class="img-up img-load-status">
                                            <img
                                                v-if="imgBase64.image6"
                                                :src="imgBase64.image6"
                                                alt=""
                                            />
                                            <img
                                                v-else
                                                :src="require('../../assets/img/othreUp-bg.png')"
                                                alt=""
                                            />
                                        </div>
                                    </div>
                                    <div
                                        v-if="showMore"
                                        class="img-up-list el-upload-list--picture-card"
                                    >
                                        <div
                                            v-if="imgBase64.image7"
                                            class="el-upload-list__item-actions"
                                        >
                                            <i
                                                class="el-icon-delete"
                                                aria-hidden="true"
                                                v-on:click="delImg('image7')"
                                            />
                                        </div>
                                        <el-input
                                            v-model="img.image7"
                                            type="file"
                                            name="image7"
                                            :accept="accept"
                                            v-on:change="getImgBase('image7')"
                                        />
                                        <div class="img-up img-load-status">
                                            <img
                                                v-if="imgBase64.image7"
                                                :src="imgBase64.image7"
                                                alt=""
                                            />
                                            <img
                                                v-else
                                                :src="require('../../assets/img/othreUp-bg.png')"
                                                alt=""
                                            />
                                        </div>
                                    </div>
                                    <div
                                        v-if="showMore"
                                        class="img-up-list el-upload-list--picture-card"
                                    >
                                        <div
                                            v-if="imgBase64.image8"
                                            class="el-upload-list__item-actions"
                                        >
                                            <i
                                                class="el-icon-delete"
                                                aria-hidden="true"
                                                v-on:click="delImg('image8')"
                                            />
                                        </div>
                                        <el-input
                                            v-model="img.image8"
                                            type="file"
                                            name="image8"
                                            :accept="accept"
                                            v-on:change="getImgBase('image8')"
                                        />
                                        <div class="img-up img-load-status">
                                            <img
                                                v-if="imgBase64.image8"
                                                :src="imgBase64.image8"
                                                alt=""
                                            />
                                            <img
                                                v-else
                                                :src="require('../../assets/img/othreUp-bg.png')"
                                                alt=""
                                            />
                                        </div>
                                    </div>
                                    <div
                                        v-if="showMore"
                                        class="img-up-list el-upload-list--picture-card"
                                    >
                                        <div
                                            v-if="imgBase64.image9"
                                            class="el-upload-list__item-actions"
                                        >
                                            <i
                                                class="el-icon-delete"
                                                aria-hidden="true"
                                                v-on:click="delImg('image9')"
                                            />
                                        </div>
                                        <el-input
                                            v-model="img.image9"
                                            type="file"
                                            name="image9"
                                            :accept="accept"
                                            v-on:change="getImgBase('image9')"
                                        />
                                        <div class="img-up img-load-status">
                                            <img
                                                v-if="imgBase64.image9"
                                                :src="imgBase64.image9"
                                                alt=""
                                            />
                                            <img
                                                v-else
                                                :src="require('../../assets/img/othreUp-bg.png')"
                                                alt=""
                                            />
                                        </div>
                                    </div>
                                </div>
                                <el-button
                                    v-if="!showMore"
                                    class="upload-more-btn"
                                    type="text"
                                    v-on:click="showMore = true"
                                >
                                    上传更多
                                </el-button>
                            </el-form-item>
                            <el-form-item label="" class="btn-center">
                                <el-button class="medium dc-cancel-btn" v-on:click="dialogClose">
                                    还未准备好
                                </el-button>
                                <el-button
                                    type="primary"
                                    class="medium confirm"
                                    :disabled="btnStatus"
                                    v-on:click="submitInfo()"
                                >
                                    确定上传
                                </el-button>
                            </el-form-item>
                        </el-form>
                </div>

                <div class="cut-off-line top">
                    <span>请按正确示例上传证件照</span>
                </div>
                <img src="@/assets/img/ocr-example.png" class="example" alt="" />
            </el-row>
        </el-dialog>
    </div>
</template>
<script>
import { httpClient } from "@/assets/js/http";
import urls from "@/api/urls";
import WxScanUpload from "./wxScanUpload.vue";
export default {
    name: "OrcUpdDialog",
    components: { WxScanUpload },
    props: {
        title: {
            type: String,
            default: "上传证件照"
        },
        width: {
            type: String,
            default: "740px"
        },
        visible: {
            type: Boolean,
            default: false
        },
        certType: {
            type: String,
            default: "00"
        },
        from: {
            type: String,
            default: ""
        },
        checkflag: {
            type: String,
            default: "1"
        }
    },
    data() {
        return {
            dialogImageUrl: "",
            activeTab: "wechat",
            accept: "image/bmp,image/png,image/jpg,image/jpeg",
            isShowWechatScan: false,
            img: {
                // faceImage: "",
                // backImage: "",
                image1: "",
                image2: "",
                image3: "",
                image4: "",
                image5: "",
                image6: "",
                image7: "",
                image8: "",
                image9: ""
            },
            imgBase64: {
                // faceImage: "",
                // backImage: "",
                image1: "",
                image2: "",
                image3: "",
                image4: "",
                image5: "",
                image6: "",
                image7: "",
                image8: "",
                image9: ""
            },
            showMore: false,
            imgCode: {
                income: "",
                asset: "",
                invest: ""
            },
            scrCode: {
                income: "",
                asset: "",
                invest: ""
            }
        };
    },
    computed: {
        btnStatus: function () {
            return !Object.values(this.imgBase64).some((value) => value.trim() !== "");
        }
    },
    watch: {},
    mounted() {
        this.isShowWechatScan = this.$cache.getCompanyInfoParam('10301003') &&
                            this.$cache.getCompanyInfoParam('10301003').indexOf('T05') > -1;
    },
    methods: {
        dialogClose() {
            this.$emit("back");
            this.cancel();
        },
        async wxScanSuccess(data) {
            const sysFileattachments = data.fileInfoList.map((fileInfo) => {
                return {
                    filetype: "24", // 固定值
                    businesscode: "0B1", // 固定值
                    fileurl: fileInfo.fileCode // 文件保存ID
                };
            });
            this.submitData(sysFileattachments);
        },
        async submitInfo() {
            // 处理入参：筛选非空图片，构造 sysFileattachments 数组
            const sysFileattachments = Object.entries(this.img)
                .filter(([key, value]) => {
                    // 仅保留值非空且非空格的属性（例如 image1 有值时保留）
                    return value && value.trim() !== "";
                })
                .map(([key, fileurl]) => {
                    // 每个非空图片生成一个附件对象
                    return {
                        filetype: "24", // 固定值
                        businesscode: "0B1", // 固定值
                        fileurl: fileurl // 对应 imageX 的值（文件保存ID）
                    };
                });
            this.submitData(sysFileattachments);
        },
        submitData(sysFileattachments){
            const info = this.$cache.getUser();
            info.sysFileattachments = sysFileattachments;
            this.$emit("success", {
                ...info
            });
            this.dialogClose();
            this.$message({
                type: "success",
                message: "上传证件成功！"
            });
        },
        cancel() {
            this.img = {
                faceImage: "",
                backImage: ""
            };
            this.imgBase64 = {
                faceImage: "",
                backImage: ""
            };
        },
        async getImgBase(index) {
            const _this = this;
            const event = window.event;
            const file = event.target && event.target.files[0];
            let k = 0;
            if (!file) {
                this.delImg(event.target.name);
                return false;
            }
            let maxSize = this.$cache.getOcrFileSize();
            if (file.size > 1024 * 1024 * maxSize) {
                this.img[event.target.name] = "";
                this.$message.warning("上传文件大小超过限制大小" + maxSize + "M，不能上传");
                return;
            }
            for (var i in this.img) {
                if (this.img[i] && file.name === this.img[i].split("\\").pop()) k++;
            }
            // if (k === 2) {
            //     this.delImg(event.target.name);
            //     this.$message.warning("不能上传相同名称的文件，请重新上传");
            //     return false;
            // }
            const reader = new FileReader();
            // 转base64
            reader.onload = function (e) {
                _this.$set(_this.imgBase64, event.target.name, e.target.result);
            };
            reader.readAsDataURL(file);

            //  构造 FormData 上传文件流（核心修改点）
            const formData = new FormData();
            // 直接 append 原始 file 对象（二进制流），字段名需与接口一致（此处为 "file"）
            formData.append("file", file);
            formData.append("filetype", 124); // 证件资料审核固定值：124
            // 新增bizParam：JSON格式，传入证件号码
            const custno = this.$cache.getUser().custno;
            formData.append("custno", custno);
            try {
                // 发送请求（无需转base64，直接传 FormData）
                const res = await httpClient.post(urls.uploadInfoFile, formData, {
                    headers: {
                        // "Content-Type": "multipart/form-data" // 必须设置为表单数据类型
                    }
                });
                if (res.code == "0") {
                    // 保存返回的 fileCode 到 imgBase64（用于后续接口入参）
                    _this.$set(_this.img, event.target.name, res.data.fileCode);
                }
            } catch (error) {
                console.error("上传失败", error);
                this.delImg(index);
                this.$message.error("文件上传失败，请重试");
            }
        },
        // 删除图片
        delImg(index) {
            this.imgBase64[index] = "";
            if (this.img[index]) {
                this.img[index] = "";
            }
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";
:deep(.el-dialog__wrapper.prop .el-dialog__body) {
    padding: 0;
}

.ocr-upd-tip {
    background: #fffaf6;
    height: 40px;
    display: flex;
    align-items: center;
    color: var(--color-text-accent);
    font-size: 14px;
    img {
        width: 18px;
        height: 18px;
        margin: 0 8px 0 20px;
    }
}

.tips {
    padding: 0 20px;
    font-size: 8rpx;
    color: var(--color-text-primary);
    line-height: 11rpx;
}

.tips-margin {
    margin-top: 15px;
}

.up-list-ocr-dialog {
    padding: 0 20px;
    :deep(.el-tabs__nav-scroll) {
        display: flex;
        justify-content: center;
    }
    :deep(.el-tabs__nav-wrap::after) {
        display: none;
    }
    .img-up-list {
        margin: 50px 0px 30px;
        display: inline-block;
        position: relative;
        .el-upload-list__item-actions {
            z-index: 100;
            i {
                font-size: $f24;
                cursor: pointer;
            }
            i:last-of-type {
                // margin-left: 20px;
            }
        }
        .el-input {
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0;
            z-index: 10;
        }
        .img-up,
        :deep(.el-input .el-input__inner) {
            width: 214px;
            height: 112px;
            line-height: 112px;
            cursor: pointer;
        }

        .img-up {
            text-align: center;
            border: 3px dashed $border-color4;
            border-radius: 10px;
            background-color: $bg1;
            overflow: hidden;
            img {
                width: 214px;
                height: 112px;
                display: inline-block;
            }
            &.img-load-status {
                width: 214px;
                height: 112px;
                border: none;
                border-radius: 6px;
            }
        }
        .img-text {
            vertical-align: middle;
            font-size: $f20;
        }
        .el-icon-plus {
            vertical-align: middle;
            font-size: $f26;
            margin-right: 7px;
            color: inherit;
            font-weight: bold;
        }
    }
    .img-up-box {
        text-align: center;
        font-size: 16px;
        .img-up-list {
            vertical-align: middle;
            margin: 10px 5px;
            &:last-of-type {
                // margin-left: 20px;
            }
        }
        span {
            margin-top: 12px;
            line-height: 16px;
            display: block;
        }
    }
    .el-form-item__error {
        top: 90%;
        left: 50%;
        -webkit-transform: translateX(-50%);
        -moz-transform: translateX(-50%);
        transform: translateX(-50%);
    }

    .btn-center {
        text-align: center;
        .confirm {
            width: 180px;
            margin-left: 40px;
        }
    }
    .cut-off-line.top {
        margin: 38px 0 13px;
    }
    .example {
        margin: 0 auto 40px;
        display: block;
    }
    .upload-more-btn {
        float: right;
    }

    .el-upload-list__item-actions {
        z-index: 100;
        i {
            font-size: $f24;
            cursor: pointer;
        }
        i:last-of-type {
            margin-left: 20px;
        }
    }
}
</style>
